import React, { Component } from 'react'
import { Switch, Route } from 'react-router-dom'

import CardsInContext from './CardsInContext'

class CurrentCards extends Component {
  render () {
    const { aufschaltung, userInfo, lang, preferences } = this.props

    return (
      <Switch>
        <Route exact path='/home' render={(history) => (
          <CardsInContext context={{
            aufschaltung: aufschaltung,
            userInfo: userInfo,
            lang: lang,
            preferences: preferences,
            navigation: {
              category: 'dashboard',
              dashboard: true
            }}} />)}
        />

        <Route exact path='/profiles' render={() => (
          <CardsInContext context={{
            aufschaltung: aufschaltung,
            lang: lang,
            preferences: preferences,
            navigation: {
              category: 'profile',
              profile: 'ALL'
            }}} />)}
        />

        <Route path='/profile/:profile' render={({ match }) => (
          <CardsInContext context={{
            aufschaltung: aufschaltung,
            lang: lang,
            preferences: preferences,
            navigation: {
              category: 'profile',
              profile: match.params.profile
            }}} />)}
        />

        <Route exact path='/apis' render={() => (
          <CardsInContext context={{
            aufschaltung: aufschaltung,
            lang: lang,
            preferences: preferences,
            navigation: {
              category: 'api',
              api: 'ALL'
            }}} />)}
        />

        <Route path='/api/:api' render={({ match }) => (
          <CardsInContext context={{
            aufschaltung: aufschaltung,
            userInfo: userInfo,
            lang: lang,
            preferences: preferences,
            navigation: {
              category: 'api',
              api: match.params.api
            }}} />)}
        />

        <Route exact path='/apps' render={() => (
          <CardsInContext context={{
            aufschaltung: aufschaltung,
            lang: lang,
            preferences: preferences,
            navigation: {
              category: 'app',
              app: 'ALL'
            }}} />)}
        />

        <Route path='/app/:app' render={({ match }) => (
          <CardsInContext context={{
            aufschaltung: aufschaltung,
            lang: lang,
            preferences: preferences,
            navigation: {
              category: 'app',
              app: match.params.app
            }}} />)}
        />

        <Route exact path='/contact' render={() => (
          <CardsInContext context={{
            aufschaltung: aufschaltung,
            lang: lang,
            preferences: preferences,
            navigation: {
              category: 'contact',
              contact: 'ALL'
            }}} />)}
        />

        <Route exact path='/doc' render={() => (
          <CardsInContext context={{
            aufschaltung: aufschaltung,
            lang: lang,
            preferences: preferences,
            navigation: {
              category: 'doc',
              doc: 'ALL'
            }}} />)}
        />

        <Route path='/doc/:doc' render={({ match }) => (
          <CardsInContext context={{
            aufschaltung: aufschaltung,
            lang: lang,
            preferences: preferences,
            navigation: {
              category: 'doc',
              doc: match.params.doc
            }}} />)}
        />
      </Switch>
    )
  }
}

export default CurrentCards



// WEBPACK FOOTER //
// ./src/components/CurrentCards.js